"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var defaultTheme = function defaultTheme(theme) {
  return {
    appearance: {
      primary: {
        containerAppearance: 'primary',
        inverseIcon: false,
        header: {
          backgroundColor: theme.color.monochrome1["default"],
          linkWithIconAppearance: 'secondary',
          inverseLinkWithIcon: false,
          interactiveIconAppearance: 'primary',
          inverseInteractiveIcon: false
        },
        footer: {
          borderColor: theme.color.monochrome2["default"]
        }
      },
      secondary: {
        containerAppearance: 'primary',
        inverseIcon: false,
        header: {
          backgroundColor: theme.color.monochrome1["default"],
          linkWithIconAppearance: 'secondary',
          inverseLinkWithIcon: false,
          interactiveIconAppearance: 'primary',
          inverseInteractiveIcon: false
        },
        footer: {
          borderColor: theme.color.monochrome2["default"]
        }
      }
    }
  };
};

var _default = defaultTheme;
exports["default"] = _default;
//# sourceMappingURL=ModalRenderer.theme.js.map